import { Switch } from '@/components/ui/switch';
import type { ControllerRenderProps } from 'react-hook-form';
import type { PolicySettingsFormData } from '../types';

interface BooleanSettingFieldProps {
  field: ControllerRenderProps<PolicySettingsFormData, string>;
  disabled?: boolean;
}

/**
 * Boolean setting field component
 * Renders a switch control for boolean policy settings
 *
 * @param field - The react-hook-form field controller props
 * @param disabled - Whether the field is disabled
 */
export function BooleanSettingField({
  field,
  disabled = false,
}: BooleanSettingFieldProps) {
  // Ensure value is boolean, defaulting to false if undefined/null
  const value = typeof field.value === 'boolean' ? field.value : false;

  const enforcedReadOnly = disabled && value;

  return (
    <div className="flex items-center space-x-2">
      <Switch
        checked={value}
        onCheckedChange={field.onChange}
        onBlur={field.onBlur}
        disabled={disabled}
        showGrayWhenChecked={enforcedReadOnly}
      />
      <span className="text-sm">{value ? 'Enabled' : 'Disabled'}</span>
    </div>
  );
}
